import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "@heroicons/react/20/solid";
import { useEntryPage } from "@App/contexts/EntryPageContext";

interface BackButtonProps {
  className?: string;
}

const BackButton = ({ className = "" }: BackButtonProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { entryPage } = useEntryPage();
  const location = useLocation();

  const handleBack = () => {
    if (entryPage && location.pathname.includes("werkstaetten")) {
      navigate(entryPage);
    } else {
      navigate(-1); // fallback
    }
  };

  return (
    <button
      onClick={handleBack}
      type="button"
      className={`text-white bg-primary border flex items-center border-gray-300 px-2.5 py-1.5 text-sm font-semibold rounded-md mb-2 ${className}`}
    >
      <ChevronLeftIcon className="-ml-0.5 size-5" />
      {t("generalWords.back")}
    </button>
  );
};

export default BackButton;
